export const animation = {
  duration: '1s',
  jiggle: { duration: '0.1s' },
};
export const debounceDelay = 300;
